module.exports = __webpack_public_path__ + "static/media/LandingPage_bg.b88ca12b.jpg";